import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { VERIFY_EMAIL_URL } from "../../features/UrlHelper";
import { handleApiError } from "../../features/errorHandler";
import { pushGTMEvent } from "../../analytics/gtm";
import Button from "../../components/Button/Button";
import "./VerifyEmail.scss";
import { Check, CircleX, Cross, Mail } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

function VerifyEmail() {
  const { openLoginModal } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [message, setMessage] = useState("");

  async function handleVerify() {
    if (!token) {
      setStatus("error");
      setMessage("Verifikačný token chýba. Skontrolujte odkaz z emailu.");
      return;
    }

    setStatus("loading");

    await axios
      .post(VERIFY_EMAIL_URL, { token: token })
      .then(() => {
        setStatus("success");
        setMessage("Váš email bol úspešne overený!");
        pushGTMEvent("complete_registration");
      })
      .catch((err) => {
        setStatus("error");
        const errMsg = handleApiError(err, "Nastala chyba pri overovaní. Skúste to znova.");
        setMessage(err.response?.status === 400 ? "Token je neplatný alebo expirovaný." : errMsg);
      });
  }

  return (
    <div className="verify-email">
      <div className="verify-email__card">
        {status === "success" ? (
          <>
            <div className="verify-email__icon verify-email__icon--success">
              <Check />
            </div>
            <h1 className="verify-email__title">Email overený</h1>
            <p className="verify-email__text">{message}</p>
            <Button
              variant="primary"
              onClick={() => {
                openLoginModal();
                navigate("/");
              }}
            >
              Prejsť na hlavnú stránku
            </Button>
          </>
        ) : status === "error" ? (
          <>
            <div className="verify-email__icon verify-email__icon--error">
              <CircleX />
            </div>
            <h1 className="verify-email__title">Overenie zlyhalo</h1>
            <p className="verify-email__text">{message}</p>
            <Button variant="primary" onClick={handleVerify}>
              Skúsiť znova
            </Button>
          </>
        ) : (
          <>
            <div className="verify-email__icon">
              <Mail />
            </div>
            <h1 className="verify-email__title">Overenie emailu</h1>
            <p className="verify-email__text">
              Kliknite na tlačidlo nižšie pre potvrdenie vašej emailovej adresy.
            </p>
            <Button
              variant="primary"
              size="lg"
              onClick={handleVerify}
              disabled={status === "loading"}
            >
              {status === "loading" ? "Overujem..." : "Potvrdiť email"}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;
